import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import { sendInvite, reset } from '../../features/foremanActions/sendInviteSlice';
import Spinner from '../Spinner';

function ForemanAddWorker({ onClose }) {

    //Get the current jobsite from the Redux store
    const  {jobsite} = useSelector((state) => state.currentJobsite);
    const  {workerUser} = useSelector((state) => state.workerAuth);
    // in the backend check if the worker is a foreman at the current jobsite. 

    const dispatch = useDispatch();

    const [workerLname, setLastName] = useState('');
    const [workerName, setName] = useState('');
    const [workerPhone, setPhone] = useState('');
    const [workerRole, setWorkerRole] = useState('');

    // Determine language
    const lang = workerUser?.language === 'Spa' ? 'Spa' : 'Eng';

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, '');
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
        }
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    };

    const handlePhoneChange = (e) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        setPhone(formattedPhoneNumber);
    };


    const onSubmit = (e) => {
        e.preventDefault();
        const inviteePhone = workerPhone.replace(/\D/g, '');
        const workerData = {
            workerName,
            workerLname,
            inviteePhone,
            workerRole,
            jobsiteId: jobsite.id,
        };
        dispatch(sendInvite(workerData));
    };
    // Track sendInviteSlice state for toasts and reset
    const { isError, isSuccess, message } = useSelector((state) => state.invitation);

    useEffect(() => {
        if (isSuccess) {
            toast.success(message || 'Invitation sent successfully');
            dispatch(reset());
        } else if (isError) {
            toast.error(message || 'Failed to send invitation');
        }
    }, [isSuccess, isError, message, dispatch]);


    return (
        <div className='form-group mx-auto max-w-2xl bg-sage p-4 rounded-lg relative'>
            {onClose && (
                <button
                    className="absolute top-2 right-2 text-orangem text-3xl font-bold hover:text-orange-600"
                    onClick={onClose}
                    type="button"
                    aria-label="Close"
                >
                    &times;
                </button>
            )}
            <div className='ml-4'>
                <div className='text-center mb-2'>
                    <h2 className='text-2xl font-sans'>
                        {lang === 'Spa' ? 'Nuevo Trabajador' : 'New Worker Form'}
                    </h2>
                </div>
            
            </div>
            <form onSubmit={onSubmit}>
                <label htmlFor='name' className='font-kanit'>
                    {lang === 'Spa' ? 'Nombre' : 'Name'}
                </label>
                <input
                    required
                    type='text'
                    name='name'
                    id='name'
                    className='form-control bg-ivory'
                    placeholder={lang === 'Spa' ? 'Juan' : 'John'}
                    value={workerName}
                    onChange={(e) => setName(e.target.value)}
                />

                <label htmlFor='workerLname' className='font-kanit'>
                    {lang === 'Spa' ? 'Apellido' : 'Last Name'}
                </label>
                <input
                    required
                    type='text'
                    name='workerLname'
                    id='workerLname'
                    className='form-control bg-ivory'
                    placeholder={lang === 'Spa' ? 'Pérez' : 'Doe'}
                    value={workerLname}
                  
                    onChange={(e) => setLastName(e.target.value)}
                />

                <label htmlFor='phone' className='font-kanit'>
                    {lang === 'Spa' ? 'Número de Teléfono' : 'Phone Number'}
                </label>
                <div className='form-group'>
                    <input
                        type='tel'
                        name='phone'
                        pattern='\d{3}-\d{3}-\d{4}'
                        maxLength='13'
                        id='phone'
                        className='form-control bg-ivory'
                        placeholder={lang === 'Spa' ? '347-123-1234' : '347-123-1234'}
                        value={workerPhone}
                        onChange={handlePhoneChange}
                    />
                </div>

                <label htmlFor='workerRole' className='font-kanit'>
                    {lang === 'Spa' ? 'Rol' : 'Role'}
                </label>
                <input
                    required
                    type='text'
                    name='workerRole'
                    id='workerRole'
                    className='form-control bg-ivory'
                    placeholder={lang === 'Spa' ? 'Pintor' : 'Framer'}
                    value={workerRole}
                    onChange={(e) => setWorkerRole(e.target.value)}
                />

                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-teal text-white p-2 rounded-lg hover:bg-orange-600 font-bold"
                    >
                        {lang === 'Spa' ? 'Enviar Invitación' : 'Send Invite'}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default ForemanAddWorker;
